// FindPw2.jsx
import { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";

export default function FindPw2({ id, phoneNumber, onDone }) {
    const navigate = useNavigate();

    const [pw, setPw] = useState("");
    const [pw2, setPw2] = useState("");
    const [submitting, setSubmitting] = useState(false);

    // 비밀번호 정책: 영문 + 숫자 + 특수문자, 8~20자
    const pwRegex = /^(?=.*[A-Za-z])(?=.*\d)(?=.*[^\w\s]).{8,20}$/;
    const isValidPw = pwRegex.test(pw);
    const isMatch = pw && pw2 && pw === pw2;

    const canSubmit =
        !!id &&
        !!phoneNumber &&
        isValidPw &&
        isMatch &&
        !submitting;

    const handleSave = async () => {
        if (!canSubmit) return;
        try {
            setSubmitting(true);
            await axios.post(`${process.env.REACT_APP_API_BASE_URL}/reset`, {
                id: (id || "").trim().toLowerCase(),
                phoneNumber,              // FindPw1에서 이미 E.164(+82...) 형태로 넘겨줬다고 가정
                newPassword: pw,
            });
            alert("비밀번호가 변경되었습니다. 새 비밀번호로 로그인하세요.");

            // 부모가 onDone을 넘겨줬으면 호출, 아니면 로그인 페이지로 이동
            if (typeof onDone === "function") onDone();
            else navigate("/");
        } catch (e) {
            console.error(e);
            const status = e?.response?.status;
            if (status === 404) {
                alert("사용자를 찾을 수 없습니다. 아이디/전화번호를 다시 확인해주세요.");
            } else {
                alert("비밀번호 변경 중 오류가 발생했습니다.");
            }
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <>
            <div className="FindId_Header">
                <p>비밀번호 찾기</p>
            </div>

            <div className="FindId_Mid">
                <p>비밀번호 재설정</p>
                <p>새 비밀번호를 입력해 주세요</p>
            </div>

            <div className="FindId_Phone">
                <div>
                    <input
                        className="input_id"
                        type="password"
                        placeholder="영문, 숫자, 특수문자 포함 8~20자 이내"
                        value={pw}
                        onChange={(e) => setPw(e.target.value)}
                        autoComplete="new-password"
                    />
                    {!isValidPw && pw && (
                        <small className="error" style={{ color: "red" }}>
                            영문/숫자/특수문자 포함 8~20자로 입력하세요.
                        </small>
                    )}

                    <input
                        className="input_id"
                        type="password"
                        placeholder="비밀번호 확인"
                        value={pw2}
                        onChange={(e) => setPw2(e.target.value)}
                        autoComplete="new-password"
                    />
                    {!isMatch && pw2 && (
                        <small className="error" style={{ color: "red" }}>
                            비밀번호가 일치하지 않습니다.
                        </small>
                    )}

                    {(!id || !phoneNumber) && (
                        <small style={{ color: "#666" }}>
                            (이전 단계 정보가 없습니다. 뒤로 가서 본인인증을 완료하세요.)
                        </small>
                    )}
                </div>
            </div>

            <div className="FindId_button">
                <button
                    onClick={handleSave}
                    disabled={!canSubmit}
                    className={`btn-submit ${canSubmit ? "is-active" : ""}`}
                >
                    저장
                </button>
            </div>
        </>
    );
}
